import React from 'react'
import { Box, FormHelperText } from '@mui/material'

import { TextField } from '~components/internal'

import { MAX_GREETING_LENGTH } from './utils'

interface GreetingFieldProps {
  value: string
  onChange: (value: string) => void
  label?: string
  id?: string
  placeholder?: string
  rows?: number
}

const GreetingField: React.FC<GreetingFieldProps> = ({
  value,
  onChange,
  label = 'Greeting message',
  id,
  placeholder = 'Enter the greeting message...',
  rows = 2,
}) => {
  const length = value.length
  return (
    <Box>
      <TextField
        label={label}
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, MAX_GREETING_LENGTH))}
        multiline
        rows={rows}
        placeholder={placeholder}
        inputProps={{ maxLength: MAX_GREETING_LENGTH }}
      />
      <FormHelperText error={length > MAX_GREETING_LENGTH} sx={{ textAlign: 'right', mx: 0 }}>
        {length.toLocaleString()} / {MAX_GREETING_LENGTH.toLocaleString()}
      </FormHelperText>
    </Box>
  )
}

export default GreetingField
